// Croqui: `components/Empty.tsx`. Substitui `components/app/empty-state.tsx`.
//
// Vazio = frase + ação (`spec/17` §7 item 6). Nunca uma tabela com zero linhas e nada mais.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import type { IconName } from './icon.tsx';
import { IconTile } from './tile.tsx';

export function Empty({
  icon = 'inbox',
  title,
  hint,
  action,
  className,
}: {
  icon?: IconName;
  title: string;
  hint?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2.5 rounded-card border border-border border-dashed px-5 py-10 text-center',
        className,
      )}
    >
      <IconTile icon={icon} size={48} iconSize={22} />
      <div className="text-14 font-semibold">{title}</div>
      {hint !== undefined && <p className="max-w-90 text-12 text-muted leading-relaxed">{hint}</p>}
      {action}
    </div>
  );
}
